import { Fragment } from 'react';

import { Box } from '@mui/material';

type InputScreenProps = {
  headline: React.ReactNode;
  helperText?: React.ReactNode;
  children?: React.ReactNode;
};
const InputScreen: React.FC<InputScreenProps> = ({
  headline,
  helperText,
  children,
}) => {
  return (
    <Fragment>
      <Box
        sx={(theme) => ({
          [theme.breakpoints.up('sm')]: {
            maxWidth: '66.667%',
          },
        })}
      >
        {headline}
        {helperText && <Box mt={2}>{helperText}</Box>}
      </Box>
      <Box mt={4}>{children}</Box>
    </Fragment>
  );
};

export default InputScreen;
